module.exports = __webpack_public_path__ + "img/shisha-vision.08b89a96.jpg";